<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M15,24c-0.827,0-1.5-0.673-1.5-1.5v-0.247c-0.73,0.162-1.479,0.244-2.233,0.244c-0.766,0-1.526-0.084-2.267-0.251V22.5
		C9,23.327,8.327,24,7.5,24H6c-0.827,0-1.5-0.673-1.5-1.5v-2.53C3.848,19.395,3.282,18.734,2.816,18H0.75C0.336,18,0,17.664,0,17.25
		v-6c0-0.414,0.336-0.75,0.75-0.75h1.32C2.757,8.732,4,7.202,5.592,6.171C5.714,6.092,5.855,6.05,6,6.05
		c0.255,0,0.491,0.128,0.63,0.342c0.225,0.347,0.126,0.812-0.221,1.037c-1.464,0.949-2.563,2.387-3.094,4.049
		C3.215,11.79,2.928,12,2.6,12H1.5v4.5h1.74c0.269,0,0.518,0.145,0.651,0.378c0.474,0.831,1.09,1.558,1.832,2.162
		C5.899,19.183,6,19.395,6,19.622V22.5h1.5v-1.241c0-0.24,0.116-0.468,0.312-0.609c0.129-0.093,0.28-0.141,0.438-0.141
		c0.081,0,0.161,0.013,0.238,0.039c0.891,0.298,1.826,0.449,2.778,0.449c0.942,0,1.866-0.148,2.748-0.439
		c0.077-0.025,0.156-0.038,0.236-0.038c0.159,0,0.311,0.049,0.439,0.142C14.884,20.803,15,21.03,15,21.27v1.23h1.5v-2.863
		c0-0.229,0.103-0.444,0.283-0.587c1.705-1.355,2.695-3.38,2.717-5.558c-0.033-2.469-1.306-4.739-3.407-6.064
		c-0.169-0.107-0.287-0.273-0.332-0.469c-0.044-0.195-0.01-0.396,0.097-0.566c0.138-0.219,0.375-0.35,0.635-0.35
		c0.141,0,0.28,0.04,0.399,0.115c2.268,1.43,3.759,3.828,4.052,6.478c0.909-0.296,1.555-1.155,1.555-2.137
		c0-0.414,0.336-0.75,0.75-0.75S24,10.086,24,10.5c0,1.814-1.284,3.345-3.035,3.681c-0.198,2.242-1.265,4.336-2.965,5.808V22.5
		c0,0.827-0.673,1.5-1.5,1.5H15z"/>
	<path d="M8.25,8.25c-0.287,0-0.545-0.16-0.672-0.417C7.489,7.653,7.475,7.45,7.539,7.26c0.064-0.19,0.198-0.343,0.378-0.432
		C8.17,6.703,8.433,6.592,8.704,6.495C7.948,5.792,7.5,4.794,7.5,3.75C7.5,1.682,9.182,0,11.25,0C13.318,0,15,1.682,15,3.75
		c0,1.062-0.438,2.044-1.201,2.746c0.27,0.096,0.531,0.207,0.783,0.332c0.179,0.089,0.314,0.242,0.378,0.432
		c0.064,0.19,0.051,0.393-0.038,0.573C14.795,8.09,14.537,8.25,14.25,8.25c-0.115,0-0.229-0.027-0.333-0.078
		c-0.819-0.405-1.741-0.62-2.667-0.62s-1.848,0.214-2.667,0.62C8.48,8.223,8.365,8.25,8.25,8.25z M11.25,1.5
		C10.009,1.5,9,2.509,9,3.75S10.009,6,11.25,6c1.241,0,2.25-1.009,2.25-2.25S12.491,1.5,11.25,1.5z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'saving-piggy-coins-alternate',
    },
    name: {
      type: String,
      required: false,
      default: 'SavingPiggyCoinsAlternate',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>